import { OrgbrainErrorCodes } from '@orgbrain/lib-data';

import { ShareholderRecord } from '../classes/shared';
import { ShareNumbers } from './sharenumber-classes';

function reverseString(str) {
  return str.split('').reverse().join('');
}

function specialCases(note: any) {
  if (note.trim() === 'Eier aksje - 1-20.000') return '1 - 20000';
  if (note.trim() === 'A1-5400  A500001-505400  A750001-755400')
    return '1-5400  500001-505400  750001-755400';
  return note;
}

export function noteToNumbers({
  note,
  timeStamp,
  eventRef,
  debug,
  index,
}: {
  note: string;
  timeStamp: number;
  eventRef: string;
  debug?: boolean;
  index?: number;
}): ShareNumbers[] {
  const numbers: ShareNumbers[] = [];
  if (debug) console.log(note);
  if (!note) {
    throw {
      code: OrgbrainErrorCodes.NOTE_CANNOT_BE_CONVERTED_TO_NUMBERS_NULL,
      message: `linje ${index}, aksjenummer er tomt`,
    };
  }
  const valid = /[^0-9\s, \-\.]/;
  note = note.trim().toLowerCase();

  note = specialCases(note);

  // WTF is this symbol !!!
  note = note.replace(/[–|_]/g, '-');
  note = note.replace(/\n/g, ',');
  note = note.replace(/\r/g, ',');
  note = note.replace(/og/g, ',');
  if (debug) console.log('A ', note);

  const match = valid.exec(note);

  if (match) {
    if (debug) console.log('match', match);
    if (match.index === 0) {
      if (debug) console.log('Reverse');
      let revStr = note.split('').reverse().join('');
      if (debug) console.log('Reverse', revStr);

      const match = valid.exec(revStr);
      if (!match) {
        throw {
          code: OrgbrainErrorCodes.NOTE_CANNOT_BE_CONVERTED_TO_NUMBERS_TRIED_REVERSING,
          message: `linje ${index}, aksjenummer: ${note}`,
        };
      } else {
        revStr = revStr.substring(0, match.index);
        note = revStr.split('').reverse().join('');
      }
    } else {
      note = note.substring(0, match.index - 1);
    }
  }

  if (debug) console.log('B ', note);

  const toksRaw: string[] = note.trim().split(/\s*,\s*/);

  const toks = toksRaw.map((x) => x.replace(/[\s|.]/g, ''));

  if (debug) console.log('C ', toks);

  for (const tok of toks) {
    if (tok.trim() === '') continue;
    const tofrom: string[] = tok.split('-');

    const from: number = +tofrom[0] - 1;
    let to: number;
    if (tofrom.length > 1) {
      to = +tofrom[1];
    } else {
      to = from + 1;
    }

    if (to <= from) {
      throw {
        code: OrgbrainErrorCodes.NOTE_CANNOT_BE_CONVERTED_TO_NUMBERS_TO_GREATER_THEN_FROM,
        message: `linje ${index}, aksjenummer: ${note}`,
      };
    }

    if (isNaN(from) || isNaN(to)) {
      // I think this impossible
      console.log({ from, to });
      throw {
        code: OrgbrainErrorCodes.NOTE_CANNOT_BE_CONVERTED_TO_NUMBERS_NAN,
        message: `linje ${index}, aksjenummer: ${note}`,
      };
    }

    const number: ShareNumbers = {
      from,
      to,
      timeStamp,
      eventRef,
    };

    numbers.push(number);
  }

  return numbers;
}

export function initNumbersFromNotes({
  records,
  timeStamp,
  eventRef,
}: {
  records: Array<ShareholderRecord>;
  timeStamp: number;
  eventRef: string;
}): ShareholderRecord[] {
  const ret: ShareholderRecord[] = [];
  let index = 1;
  for (const record of records) {
    const numbers: ShareNumbers[] = noteToNumbers({
      note: record.notes || '',
      timeStamp,
      eventRef,
      index,
    });

    const newrecord: ShareholderRecord = { ...record };
    newrecord.numbers = numbers;
    ret.push(newrecord);
    index++;
  }

  return ret;
}
